import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { BrowserRouter as Router, Switch, Route, withRouter, Link } from 'react-router-dom';
import Search from './search.js';
import * as routes from '../../common/constants.ts';
import Notifications from './notifications.js';
import AngoliaBuscador from './angolia';
import ClientServices from './client-services.js';

function MobileMenu(props) {
  useEffect(() => {
    props.closeMobileMenu();
  }, [window.location.pathname]);

  // console.log(window.location.pathname)

  const mobileUserText = () => {
    if (props.username) {
      return (
        <div className="toolbar-item">
          <Link to="/userInfo/users">
            <div
              onClick={(e) => {
                props.closeMobileMenu();
              }}
            >
              <span className="text-label">{props.username}</span>
              <i className="icon-user" />
              <span className="text-label"></span>
            </div>
          </Link>
        </div>
      );
    } else {
      return (
        <div className="toolbar-item">
          <Link to="/login">
            <div onClick={props.closeMobileMenu}>
              <i className="icon-user" />
              <span className="text-label">{'Entrar / Registrarse'}</span>
            </div>
          </Link>
        </div>
      );
    }
  };

  return (
    <><div className="mobile-menu open">
      <div className="mobile-search">
        <form className="input-group" method="get">
          <span className="input-group-btn">
            <button type="submit">
              <i className="icon-search" />
            </button>
          </span>
          <AngoliaBuscador></AngoliaBuscador>

          {/* <Search /> */}
        </form>
      </div>
    </div>
    <div className={`mobile-menu ${props.MobileMenuOpen ? ' open' : ''}`}>
        {/* Search Box*/}
        {/* Toolbar*/}
        <div className="toolbar">
          <div className="toolbar-item">
            <Link to="#">
              <div>
                <i className="icon-bell"></i>
                <span className="text-label">Notificaciones</span>
              </div>
            </Link>
            {/* <ul className="toolbar-dropdown lang-dropdown w-100">
                  <li className="px-3 pt-1 pb-2">
                      {/* <select className="form-control form-control-sm">
          <option className='text-danger' value="usd">Pedido cancelado</option>
          <option className='text-info' value="usd">Su pedido está en camino</option>
        </select> */}
            {/* </li>
                  <li>
                      <a>
                          <p className='text-info'>Su pedido está en camino</p>
                      </a>
                  </li>
                  <li>
                      <a>
                          <p className='text-danger'>Pedido cancelado</p>
                      </a>
                  </li>
                  <li>

                  </li>
              </ul> */}
            <Notifications
              NotificationsMsg={props.NotificationsMsg}
              getNotifications={props.getNotifications}
              isMobile={true} />
          </div>
          <ClientServices isMobile={true} />
          {/* <div className="toolbar-item"><Link to="/userInfo/wishlist">
                <div>
                    <span className="compare-icon">
                        <i className="icon-heart" />
                        <span className="count-label">{props.wishlistItems ? props.wishlistItems.length : 0} </span>
                    </span>
                    <span className="text-label">Favoritos</span>
                </div>
            </Link></div> */}
          {mobileUserText()}
        </div>
        {/* Slideable (Mobile) Menu*/}
        <nav className="slideable-menu" onClick={props.navClick}>
          <ul className="menu" data-initial-height={670}>
            <li className="has-children" onClick={props.closeMobileMenu}>
              <span>
                <a href="/">
                  <i className="icon-home mr-2" />
                  Home
                </a>
              </span>
            </li>
            <li className="has-children ">
              <span>
                <Link to="/productLane/00000002">
                  {' '}
                  <i className="icon-file-text mr-2" />
                  Papel
                </Link>
                <span className="sub-menu-toggle" />
              </span>
              <ul className="slideable-submenu">
                <li className=" has-children">
                  <span>
                    <Link to={routes.ResmasRoute}>Resmas</Link>
                    <span className="sub-menu-toggle" />
                  </span>
                  <ul className="slideable-submenu">
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.resmas_multifuncionRoute}>
                        <strong>Resmas Multifunción</strong>
                      </Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Resmas_colorRoute}>
                        <strong>Resmas Color</strong>
                      </Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Papeles_especialesRoute}>Papeles especiales</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Formulario_continuoRoute}>Formulario continuo</Link>
                    </li>
                  </ul>
                </li>
                <li className=" has-children">
                  <span>
                    <Link to={routes.CuadernosBlocksRoute}>Cuadernos y Blocks</Link>
                    <span className="sub-menu-toggle" />
                  </span>
                  <ul className="slideable-submenu">
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.CuadernosRoute}>
                        <strong>Cuadernos</strong>
                      </Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.BlocksRoute}>
                        <strong>Blocks</strong>
                      </Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.CuadernillosRoute}>Cuadernillos</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Repuesto_cuadernosRoute}>Repuesto cuadernos</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Block_para_rotafolioRoute}>Block para rotafolio</Link>
                    </li>
                  </ul>
                </li>
                <li className="has-children">
                  <span>
                    <Link to={routes.SobresRoute}>Sobres y Comerciales</Link>
                    <span className="sub-menu-toggle" />
                  </span>
                  <ul className="slideable-submenu">
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Sobres_manilaRoute}>
                        <strong>Sobres manila</strong>
                      </Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Sobres_papel_obraRoute}>
                        <strong>Sobres papel obra</strong>
                      </Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Sobres_plasticosRoute}>Sobres plásticos</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.FormulariosRoute}>Formularios</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Libros_comercialesRoute}>Libros Comerciales</Link>
                    </li>
                  </ul>
                </li>
                <li className="has-children">
                  <span>
                    <Link to={routes.RollosRoute}>Rollos</Link>
                    <span className="sub-menu-toggle" />
                  </span>
                  <ul className="slideable-submenu">
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Rollos_Maq_SumarRoute}>
                        <strong>Rollos Maq Sumar</strong>
                      </Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Rollos_faxRoute}>Rollos fax</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Rollos_papel_filmRoute}>Rollos papel film</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Rollos_ContactRoute}>Rollos Contact</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Rollos_de_PVCRoute}>Rollos de PVC</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Rollos_para_plottersRoute}>Rollos para plotters</Link>
                    </li>
                  </ul>
                </li>
                <li className="has-children">
                  <span>
                    <Link to={routes.PapelesEspecificosRoute}>Papeles específicos</Link>
                    <span className="sub-menu-toggle" />
                  </span>
                  <ul className="slideable-submenu">
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Papel_CarbonicoRoute}>Papel Carbónico</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Papel_maderaRoute}>Papel madera</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Papel_misioneroRoute}>Papel misionero</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.CartulinaRoute}>Cartulina</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Papel_comercioRoute}>Papel comercio</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Papel_de_forrarRoute}>Papel de forrar</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Papel_de_CalcarRoute}>Papel de Calcar</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Papel_para_dibujoRoute}>Papel para dibujo</Link>
                    </li>
                  </ul>
                </li>
                <li className="has-children">
                  <span>
                    <Link to={routes.EscrituraOtrosRoute}>Otros</Link>
                    <span className="sub-menu-toggle" />
                  </span>
                  <ul className="slideable-submenu">
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.EtiquetasRoute}>
                        <strong>Etiquetas</strong>
                      </Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Tacos_de_papelRoute}>
                        <strong>Tacos de papel</strong>
                      </Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Tacos_calendariosRoute}>Tacos calendarios</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Lomo_para_biblioratosRoute}>
                        <strong>Lomo para biblioratos</strong>
                      </Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.TalonarioRoute}>Talonarios</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.OjalillosRoute}>Ojalillos</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Hojas_para_plastificarRoute}>Hojas para plastificar</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.TransparenciasRoute}>Transparencias</Link>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
            <li className="has-children">
              <span>
                <Link to="/productLane/00000001">
                  {' '}
                  <i className="icon-edit-3 mr-2" />
                  Escritura
                </Link>
                <span className="sub-menu-toggle" />
              </span>
              <ul className="slideable-submenu">
                <li className=" has-children">
                  <span>
                    <Link to={routes.EscrituraTintaRoute}>Tinta</Link>
                    <span className="sub-menu-toggle" />
                  </span>
                  <ul className="slideable-submenu">
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.BoligrafosRoute}>
                        <strong>Boligrafos</strong>
                      </Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.RollersRoute}>
                        <strong>Rollers</strong>
                      </Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.LapiceraRoute}>Lapiceras</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.CorrectoresRoute}>Correctores</Link>
                    </li>
                  </ul>
                </li>
                <li className=" has-children">
                  <span>
                    <Link to={routes.EscrituraLapizRoute}>Lapiz</Link>
                    <span className="sub-menu-toggle" />
                  </span>
                  <ul className="slideable-submenu">
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.LapicesRoute}>
                        <strong>Lapices</strong>
                      </Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.PortaminasRoute}>
                        <strong>Portaminas</strong>
                      </Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.MinasRoute}>Minas</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Lapices_de_colorRoute}>Lapices de color</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.SacapuntasRoute}>Sacapuntas</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.GomasRoute}>Gomas</Link>
                    </li>
                  </ul>
                </li>
                <li className="has-children">
                  <span>
                    <Link to={routes.EscrituraMarcadorRoute}>Marcador</Link>
                    <span className="sub-menu-toggle" />
                  </span>
                  <ul className="slideable-submenu">
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.ResaltadoresRoute}>
                        <strong>Resaltadores</strong>
                      </Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.MarcadoresRoute}>
                        <strong>Marcadores</strong>
                      </Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.CorrectoresRoute}>Correctores</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Tinta_para_marcadoresRoute}>Tinta para marcadores</Link>
                    </li>
                  </ul>
                </li>
                <li className="has-children">
                  <span>
                    <Link to={routes.BorradoRoute}>Borrado</Link>
                    <span className="sub-menu-toggle" />
                  </span>
                  <ul className="slideable-submenu">
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.CorrectoresRoute}>
                        <strong>Correctores</strong>
                      </Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.GomasRoute}>
                        <strong>Gomas</strong>
                      </Link>
                    </li>
                  </ul>
                </li>
                <li className="has-children">
                  <span>
                    <Link to={routes.EscrituraRepuestosRoute}>Repuesto</Link>
                    <span className="sub-menu-toggle" />
                  </span>
                  <ul className="slideable-submenu">
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.MinasRoute}>
                        <strong>Minas</strong>
                      </Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Tanque_para_Roller_ballRoute}>Tanque para Roller Ball</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Tanque_para_boligrafoRoute}>Tanque para boligrafo</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Cartucho_para_lapiceraRoute}>Cartucho para lapicera</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Tinta_para_marcadoresRoute}>Tinta para marcadores</Link>
                    </li>
                  </ul>
                </li>
                <li className="has-children">
                  <span>
                    <Link to={routes.EscrituraOtrosRoute}>Otros</Link>
                    <span className="sub-menu-toggle" />
                  </span>
                  <ul className="slideable-submenu">
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Set_de_escrituraRoute}>Set de escritura</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.TizasRoute}>Tizas</Link>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>

            <li className="has-children">
              <span>
                <Link to="/productLane/00000003">
                  <i className="icon-printer mr-2" />
                  Toner y Cartuchos
                </Link>
                <span className="sub-menu-toggle" />
              </span>
              <ul className="slideable-submenu">
                <li className=" has-children">
                  <span>
                    <Link to="#">Toner, Cartuchos tinta</Link>
                    <span className="sub-menu-toggle" />
                  </span>
                  <ul className="slideable-submenu">
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to="/BuscadorInsumos">Toner, Cartuchos tinta, Insumos de impresión</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Cinta_Para_Matriz_de_puntoRoute}>Cinta Para Matriz de punto</Link>
                    </li>
                  </ul>
                </li>
                {/* <li className=" has-children"><span><Link to="#">Almacenamiento</Link><span className="sub-menu-toggle" /></span>
                      <ul className="slideable-submenu">
                          <li onClick={props.toggleMobileMenuOpen}><Link to={routes.CDsRoute}>CDs</Link></li>
                          <li onClick={props.toggleMobileMenuOpen}><Link to={routes.DVDRoute}>DVD</Link></li>
                          <li onClick={props.toggleMobileMenuOpen}><Link to={routes.MemoriasRoute}>Memorias</Link></li>
                          <li onClick={props.toggleMobileMenuOpen}><Link to={routes.Cinta_back_upRoute}>Cinta back up</Link></li>

                      </ul>
                  </li> */}
                {/* <li className="has-children"><span><Link to="#">Porta</Link><span className="sub-menu-toggle" /></span>
                      <ul className="slideable-submenu">
                          <li onClick={props.toggleMobileMenuOpen}><Link to={routes.Porta_CDsRoute}>Porta CDs</Link></li>
                          <li onClick={props.toggleMobileMenuOpen}><Link to={routes.Porta_DVDsRoute}>Porta DVDs</Link></li>
                          <li onClick={props.toggleMobileMenuOpen}><Link to={routes.Porta_diskettesRoute}>Porta diskettes</Link></li>

                      </ul>
                  </li> */}
                {/* <li className="has-children"><span><Link to="#">Periféricos</Link><span className="sub-menu-toggle" /></span>
                      <ul className="slideable-submenu">
                          <li onClick={props.toggleMobileMenuOpen}><Link to={routes.MouseRoute}>Mouse</Link></li>
                          <li onClick={props.toggleMobileMenuOpen}><Link to={routes.TecladosRoute}>Teclados</Link></li>
                          <li onClick={props.toggleMobileMenuOpen}><Link to={routes.Web_CamRoute}>Web Cam</Link></li>
                          <li onClick={props.toggleMobileMenuOpen}><Link to={routes.AuricularesRoute}>Auriculares</Link></li>
                          <li onClick={props.toggleMobileMenuOpen}><Link to={routes.ParlantesRoute}>Parlantes</Link></li>
                          <li onClick={props.toggleMobileMenuOpen}><Link to={routes.Pad_mouseRoute}>Pad mouse</Link></li>
                      </ul>
                  </li> */}
                {/* <li className="has-children"><span><Link to="#">Otros</Link><span className="sub-menu-toggle" /></span>
                      <ul className="slideable-submenu">
                          <li onClick={props.toggleMobileMenuOpen}><Link to={routes.Power_BankRoute}>Power Bank</Link></li>
                          <li onClick={props.toggleMobileMenuOpen}><Link to={routes.CablesRoute}>Cables</Link></li>
                          <li onClick={props.toggleMobileMenuOpen}><Link to={routes.Filtros_monitorRoute}>Filtros monitor</Link></li>
                          <li onClick={props.toggleMobileMenuOpen}><Link to={routes.FundasRoute}>Fundas</Link></li>
                          <li onClick={props.toggleMobileMenuOpen}><Link to={routes.Aire_ComprimidoRoute}>Aire Comprimido</Link></li>
                          <li onClick={props.toggleMobileMenuOpen}><Link to={routes.Copy_holderRoute}>Copy holder</Link></li>
                          <li onClick={props.toggleMobileMenuOpen}><Link to={routes.Brazos_Porta_MonitorRoute}>Brazos Porta Monitor</Link></li>
                          <li onClick={props.toggleMobileMenuOpen}><Link to={routes.HerramientasRoute}>Herramientas</Link></li>
                      </ul>
                  </li> */}
              </ul>
            </li>

            <li className="has-children">
              <span>
                <Link to="/productLane/00000005">
                  <i className="icon-package mr-2" />
                  Básicos
                </Link>
                <span className="sub-menu-toggle" />
              </span>
              <ul className="slideable-submenu">
                <li className="has-children">
                  <span>
                    <Link to={routes.AbrochadorasPerforadorasRoute}>Abrochadoras y Perforadoras</Link>
                    <span className="sub-menu-toggle" />
                  </span>
                  <ul className="slideable-submenu">
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.AbrochadorasRoute}>
                        <strong>Abrochadoras</strong>
                      </Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.PerforadorasRoute}>
                        <strong>Perforadoras</strong>
                      </Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.SacabrochesRoute}>Sacabroches</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Repuesto_perforadorasRoute}>Repuesto perforadoras</Link>
                    </li>
                  </ul>
                </li>
                <li className="has-children">
                  <span>
                    <Link to={routes.BrochesClipsOtrosRoute}>Broches, Clips y Otros</Link>
                    <span className="sub-menu-toggle" />
                  </span>
                  <ul className="slideable-submenu">
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Broches_para_abrochadorasRoute}>
                        <strong>Broches para abrochadora</strong>
                      </Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.ClipsRoute}>
                        <strong>Clips</strong>
                      </Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Aprieta_papelRoute}>
                        <strong>Aprieta papel</strong>
                      </Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Broches_dos_puntasRoute}>Broches dos puntas</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Broches_NepacoRoute}>Broches Nepaco</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Broches_NixsoRoute}>Broches Nixso</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.ArosRoute}>Aros</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.ArandelasRoute}>Arandelas</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.ChinchesRoute}>Chinches</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.AlfileresRoute}>Alfileres</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.SeñaladoresRoute}>Señaladores</Link>
                    </li>
                  </ul>
                </li>
                <li className="has-children">
                  <span>
                    <Link to={routes.BasicosOficinasRoute}>Básicos Oficina</Link>
                    <span className="sub-menu-toggle" />
                  </span>
                  <ul className="slideable-submenu">
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.AdhesivosRoute}>
                        <strong>Adhesivos</strong>
                      </Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Cintas_adhesivasRoute}>
                        <strong>Cintas adhesivas</strong>
                      </Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.CestoRoute}>
                        <strong>Cesto</strong>
                      </Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.TijerasRoute}>
                        <strong>Tijeras</strong>
                      </Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.AlmohadillasRoute}>Almohadillas</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.SellosRoute}>Sellos</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Tinta_para_sellosRoute}>Tinta para sellos</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.ReglasRoute}>Reglas</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.MojadedosRoute}>Mojadedos</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Pincha_papelesRoute}>Pincha Papeles</Link>
                    </li>
                  </ul>
                </li>
                <li className="has-children">
                  <span>
                    <Link to={routes.ElementosEscritorioRoute}>Elementos de Escritorio</Link>
                    <span className="sub-menu-toggle" />
                  </span>
                  <ul className="slideable-submenu">
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Organizadores_de_EscritorioRoute}>
                        <strong>Organizadores de Escritorio</strong>
                      </Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Bandeja_porta_papelesRoute}>
                        <strong>Bandeja porta papeles</strong>
                      </Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Porta_lapizRoute}>
                        <strong>Porta lápiz</strong>
                      </Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Porta_clipsRoute}>
                        <strong>Porta clips</strong>
                      </Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Porta_tacoRoute}>
                        <strong>Porta taco</strong>
                      </Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Porta_taco_calendarioRoute}>Porta taco calendario</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Porta_rolloRoute}>Porta rollo</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.PortasellosRoute}>Portasellos</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.PosasobresRoute}>Posasobres</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.AbrecartasRoute}>Abrecartas</Link>
                    </li>
                  </ul>
                </li>
                <li className="has-children">
                  <span>
                    <Link to={routes.BasicosAccesoriosRoute}>Accesorios</Link>
                    <span className="sub-menu-toggle" />
                  </span>
                  <ul className="slideable-submenu">
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Cintas_maquinas_escribirRoute}>Cintas máquinas escribir</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.AgendasRoute}>Agendas</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Repuesto_agendaRoute}>Repuesto agenda</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.PilasRoute}>Pilas</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.RevisteroRoute}>Revistero</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.CofresRoute}>Cofres</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Porta_credencialRoute}>Porta credencial</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Tubo_Porta_PlanoRoute}>Tubo Porta Plano</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Detector_de_BilletesRoute}>Detector de Billetes</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.LupasRoute}>Lupas</Link>
                    </li>
                  </ul>
                </li>
                <li className="has-children">
                  <span>
                    <Link to={routes.EmpaqueRoute}>Empaque</Link>
                    <span className="sub-menu-toggle" />
                  </span>
                  <ul className="slideable-submenu">
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Cintas_embalajeRoute}>
                        <strong>Cintas embalaje</strong>
                      </Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Bandas_elasticasRoute}>
                        <strong>Bandas elásticas</strong>
                      </Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.CortantesRoute}>
                        <strong>Cortantes</strong>
                      </Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Repuesto_cortanteRoute}>Repuesto cortante</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.HilosRoute}>Hilos</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.BolsasRoute}>Bolsas</Link>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>

            <li className="has-children">
              <span>
                <Link to="/productLane/00000006">
                  <i className="icon-archive mr-2" />
                  Archivo
                </Link>
                <span className="sub-menu-toggle" />
              </span>
              <ul className="slideable-submenu">
                <li className="has-children">
                  <span>
                    <Link to={routes.ArchivoRoute}>Archivo</Link>
                    <span className="sub-menu-toggle" />
                  </span>
                  <ul className="slideable-submenu">
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Cajas_ArchivoRoute}>
                        <strong>Cajas Archivo</strong>
                      </Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Cajas_Fibra_NegraRoute}>
                        <strong>Cajas Fibra Negra</strong>
                      </Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.CarpeterosRoute}>Carpeteros</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.FicherosRoute}>Ficheros</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.ClasificadoresRoute}>Clasificadores</Link>
                    </li>
                  </ul>
                </li>
                <li className="has-children">
                  <span>
                    <Link to={routes.CarpetaPresentacionRoute}>Carpetas de Presentación</Link>
                    <span className="sub-menu-toggle" />
                  </span>
                  <ul className="slideable-submenu">
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Carpetas_de_presentacionRoute}>
                        <strong>Carpetas de presentación</strong>
                      </Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Carpetas_base_opacaRoute}>
                        <strong>Carpetas base opaca</strong>
                      </Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Carpeta_con_bolsillosRoute}>
                        <strong>Carpeta con bolsillos</strong>
                      </Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Carpetas_en_LRoute}>Carpetas en L</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Carpetas_plasticas_sin_anillosRoute}>
                        Carpetas plásticas sin anillos
                      </Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Carpetas_con_vainaRoute}>Carpetas con vaina</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Carpetas_con_clip_deslizableRoute}>Carpetas con clip deslizable</Link>
                    </li>
                  </ul>
                </li>
                <li className="has-children">
                  <span>
                    <Link to={routes.CarpetasVariasRoute}>Carpetas Varias</Link>
                    <span className="sub-menu-toggle" />
                  </span>
                  <ul className="slideable-submenu">
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.BiblioratosRoute}>
                        <strong>Biblioratos</strong>
                      </Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Lomo_para_biblioratosRoute}>
                        <strong>Lomo para biblioratos</strong>
                      </Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Carpetas_internasRoute}>
                        <strong>Carpetas internas</strong>
                      </Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Carpetas_colgantesRoute}>
                        <strong>Carpetas colgantes</strong>
                      </Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Carpetas_de_cartulinaRoute}>
                        <strong>Carpetas de cartulina</strong>
                      </Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Carpetas_con_folioRoute}>
                        <strong>Carpetas con folio</strong>
                      </Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Carpetas_con_elasticosRoute}>Carpetas con elástico</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Carpetas_con_anillosRoute}>Carpetas con anillos</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Carpetas_broche_VeloxRoute}>Carpetas broche Velox</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Carpetas_broche_KismetRoute}>Carpetas broche Kismet</Link>
                    </li>
                  </ul>
                </li>
                <li className="has-children">
                  <span>
                    <Link to={routes.AccesoriosCarpetasRoute}>Accesorios para Carpetas</Link>
                    <span className="sub-menu-toggle" />
                  </span>
                  <ul className="slideable-submenu">
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.SeparadoresRoute}>
                        <strong>Separadores</strong>
                      </Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.FoliosRoute}>
                        <strong>Folios</strong>
                      </Link>
                    </li>
                  </ul>
                </li>
                <li className="has-children">
                  <span>
                    <Link to={routes.ArchivoOtrosRoute}>Otros</Link>
                    <span className="sub-menu-toggle" />
                  </span>
                  <ul className="slideable-submenu">
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.EspiralesRoute}>Espirales</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Tapas_anilladoRoute}>Tapas Anillado</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Porta_blocksRoute}>Porta blocks</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Indice_telefonicoRoute}>Índice telefónico</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.TarjeterosRoute}>Tarjeteros</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Repuesto_tarjeteroRoute}>Repuesto tarjetero</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.FichasRoute}>Fichas</Link>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>

            <li className="has-children">
              <span>
                <Link to="/productLane/00000009">
                  <i className="icon-airplay mr-2" />
                  Presentación
                </Link>
                <span className="sub-menu-toggle" />
              </span>
              <ul className="slideable-submenu">
                <li className="has-children">
                  <span>
                    <Link to={routes.PizarrasRoute}>Pizarras</Link>
                    <span className="sub-menu-toggle" />
                  </span>
                  <ul className="slideable-submenu">
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Cajas_ArchivoRoute}>
                        <strong>Cajas Archivo</strong>
                      </Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Cajas_Fibra_NegraRoute}>
                        <strong>Cajas Fibra Negra</strong>
                      </Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.CarpeterosRoute}>Carpeteros</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.FicherosRoute}>Ficheros</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.ClasificadoresRoute}>Clasificadores</Link>
                    </li>
                  </ul>
                </li>
                <li className="has-children">
                  <span>
                    <Link to={routes.ComunicacionVisualRoute}>Comunicación Visual</Link>
                    <span className="sub-menu-toggle" />
                  </span>
                  <ul className="slideable-submenu">
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Carpetas_de_presentacionRoute}>
                        <strong>Carpetas de presentación</strong>
                      </Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Carpetas_base_opacaRoute}>
                        <strong>Carpetas base opaca</strong>
                      </Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Carpeta_con_bolsillosRoute}>
                        <strong>Carpeta con bolsillos</strong>
                      </Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Carpetas_en_LRoute}>Carpetas en L</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Carpetas_plasticas_sin_anillosRoute}>
                        Carpetas plásticas sin anillos
                      </Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Carpetas_con_vainaRoute}>Carpetas con vaina</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Carpetas_con_clip_deslizableRoute}>Carpetas con clip deslizable</Link>
                    </li>
                  </ul>
                </li>
                <li className="has-children">
                  <span>
                    <Link to={routes.PresentacionAccesoriosRoute}>Accesorios</Link>
                    <span className="sub-menu-toggle" />
                  </span>
                  <ul className="slideable-submenu">
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.BiblioratosRoute}>
                        <strong>Biblioratos</strong>
                      </Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Lomo_para_biblioratosRoute}>
                        <strong>Lomo para biblioratos</strong>
                      </Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Carpetas_internasRoute}>
                        <strong>Carpetas internas</strong>
                      </Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Carpetas_colgantesRoute}>
                        <strong>Carpetas colgantes</strong>
                      </Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Carpetas_de_cartulinaRoute}>
                        <strong>Carpetas de cartulina</strong>
                      </Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Carpetas_con_folioRoute}>
                        <strong>Carpetas con folio</strong>
                      </Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Carpetas_con_elasticosRoute}>Carpetas con elástico</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Carpetas_con_anillosRoute}>Carpetas con anillos</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Carpetas_broche_VeloxRoute}>Carpetas broche Velox</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Carpetas_broche_KismetRoute}>Carpetas broche Kismet</Link>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>

            <li className="has-children">
              <span>
                <Link to="/productLane/00000008">
                  <i className="icon-tablet mr-2" />
                  Electrónicos
                </Link>
                <span className="sub-menu-toggle" />
              </span>
              <ul className="slideable-submenu">
                <li className="has-children">
                  <span>
                    <Link to={routes.CalculadorasAccesoriosRoute}>Calculadoras y Accesorios</Link>
                    <span className="sub-menu-toggle" />
                  </span>
                  <ul className="slideable-submenu">
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.CalculadorasRoute}>
                        <strong>Calculadoras</strong>
                      </Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Rodillo_entintadorRoute}>Rodillo entintador</Link>
                    </li>
                  </ul>
                </li>
                <li className="has-children">
                  <span>
                    <Link to={routes.RotuladorasAccesoriosRoute}>Rotuladoras y Accesorios</Link>
                    <span className="sub-menu-toggle" />
                  </span>
                  <ul className="slideable-submenu">
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.RotuladoraRoute}>
                        <strong>Rotuladora</strong>
                      </Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Cinta_rotuladoraRoute}>Cinta rotuladora</Link>
                    </li>
                  </ul>
                </li>
                <li className="has-children">
                  <span>
                    <Link to={routes.MultifuncionFaxRoute}>Multifunción y Fax</Link>
                    <span className="sub-menu-toggle" />
                  </span>
                  <ul className="slideable-submenu">
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.MultifuncionRoute}>Multifunción</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Equipo_de_faxRoute}>Equipo de fax</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Film_para_faxRoute}>Film para fax</Link>
                    </li>
                  </ul>
                </li>
                <li className="has-children">
                  <span>
                    <Link to={routes.DesrtructoraGuillotinasRoute}>Destructoras y Guillotinas</Link>
                    <span className="sub-menu-toggle" />
                  </span>
                  <ul className="slideable-submenu">
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Destructora_de_documentosRoute}>
                        <strong>Destructora de documentos</strong>
                      </Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.GuillotinasRoute}>Guillotinas</Link>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>

            <li className="has-children">
              <span>
                <Link to="/productLane/00000007">
                  <i className="icon-coffee mr-2" />
                  Cafetería
                </Link>
                <span className="sub-menu-toggle" />
              </span>
              <ul className="slideable-submenu">
                <li className="has-children">
                  <span>
                    <Link to={routes.CafeMateTeRoute}>Café, Mate y Té</Link>
                    <span className="sub-menu-toggle" />
                  </span>
                  <ul className="slideable-submenu">
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.CafeRoute}>Café</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.MateRoute}>Mate</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.TeRoute}>Té</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Filtro_para_cafeRoute}>Filtro para café</Link>
                    </li>
                  </ul>
                </li>
                <li className="has-children">
                  <span>
                    <Link to={routes.LecheEndulzantesRoute}>Leche y Endulzantes</Link>
                    <span className="sub-menu-toggle" />
                  </span>
                  <ul className="slideable-submenu">
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Leche_en_polvoRoute}>Leche en polvo</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.AzucarRoute}>Azúcar</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.EdulcoranteRoute}>Edulcorante</Link>
                    </li>
                  </ul>
                </li>
                <li className="has-children">
                  <span>
                    <Link to={routes.CafeteriaAccesoriosRoute}>Accesorios</Link>
                    <span className="sub-menu-toggle" />
                  </span>
                  <ul className="slideable-submenu">
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.ServilletasRoute}>Servilletas</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.RevolvedoresRoute}>Revolvedores</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.Rollos_cocinaRoute}>Rollos cocina</Link>
                    </li>
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.VasosRoute}>Vasos</Link>
                    </li>{' '}
                  </ul>
                </li>
                <li className="has-children">
                  <span>
                    <Link to={routes.CafeteriaGalletitasRoute}>Galletitas</Link>
                    <span className="sub-menu-toggle" />
                  </span>
                  <ul className="slideable-submenu">
                    <li onClick={props.toggleMobileMenuOpen}>
                      <Link to={routes.GalletitasRoute}>Galletitas</Link>
                    </li>{' '}
                  </ul>
                </li>
              </ul>
            </li>

            <li>
              <span>
                <Link to="/productLane/PlanetPlus">
                  <i className="icon-plus mr-2" />
                  PlanetPlus
                </Link>
                <span className="sub-menu-toggle" />
              </span>
            </li>
            <li className="has-children">
              {/* <span>
      <span>
        <i className="icon-badge mr-2" />
        Ofertas y Novedades
      </span>
      <span className="sub-menu-toggle" />
    </span> */}
              <span>
                <Link>
                  <i className="icon-badge mr-2" />
                  Ofertas y Novedades
                </Link>
                <span className="sub-menu-toggle" />
              </span>
              <ul className="slideable-submenu">
                <li onClick={props.toggleMobileMenuOpen}>
                  <Link to={'/Ofertas'}>
                    <strong>Ofertas</strong>
                  </Link>
                </li>
                <li onClick={props.toggleMobileMenuOpen}>
                  <Link to={'/Novedades'}>
                    <strong>Novedades</strong>
                  </Link>
                </li>
              </ul>
            </li>
            <li
              onClick={() => {
                props.handleLogout();
                // window.location.replace('/');
              } }
            >
              {/* <span>
      <span>
        <i className="icon-log-out mr-2" />
        Cerrar sesión
      </span>
      <span className="sub-menu-toggle" />
    </span> */}
              <span>
                <Link>
                  <i className="icon-log-out mr-2" />
                  Cerrar sesión
                </Link>
                <span className="sub-menu-toggle" />
              </span>
            </li>
          </ul>
        </nav>
      </div></>
  );
}

export default withRouter(MobileMenu);
